<template>
    <div v-if="showAgeCheck" class="age-check-modal">
        <div class="age-check-modal-bg"></div>
        <div class="age-check-modal-box">
            <p class="age-check-modal__title">
                <span>Age restricted </span>
                content
            </p>
            <p>Please confirm you are above the legal drinking age in your country.</p>
            <p
                v-if="error"
                class="invalid-message"
            >
                {{ error }}
            </p>
            <div
                v-else
                class="button-row"
            >
                <button
                    @click="confirm"
                    class="button button-outline"
                >
                    Yes
                </button>
                <button
                    @click="decline"
                    class="button button-outline"
                >
                    No
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Cookie from 'js-cookie';

    export default {
        name: 'intro',
        data() {
            return {
                showAgeCheck: !Cookie.get('age_verified', true),
                error: '',
            };
        },
        mounted() {
            if (this.showAgeCheck) {
                document.querySelector('.main').classList.add('blur');
            }
        },
        methods: {
            confirm() {
                Cookie.set('age_verified', true, { expires: 14 });
                document.querySelector('.main').classList.remove('blur');
                this.showAgeCheck = false;
            },
            decline() {
                this.error = 'You can\' enter the site if you\'re not old enough';
            },
        },
    };
</script>

<style lang="scss">
    .age-check-modal {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5000;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100vh;

        &-bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            background: rgba(#000, 0.5);
            filter: blur(5px);
        }

        p {
            margin: 0 0 32px;
            font-size: 14px;

            &.invalid-message {
                color: $error-red;
            }

            &.age-check-modal__title {
                margin: 0 0 8px;
                font-size: 35px;
                font-weight: bold;
                line-height: 1.3;
                text-transform: uppercase;

                @include respond-to(md) {
                    font-size: 48px;
                }

                span {
                    color: $shamrock;
                }
            }
        }

        &-box {
            position: relative;
            width: calc(100% - 60px);
            max-width: 600px;
            padding: 40px;
            background: #000 url(asset('tg_right.png')) bottom left no-repeat;

            @include respond-to(md) {
                padding: 80px 140px;
            }

            .button-row {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .button {
                    flex: 0 0 47%;

                    &-outline {
                        color: #fff;
                        border: 2px solid #fff;
                    }
                }
            }
        }
    }

    @keyframes scale {
        0% {
            opacity: 0;
            transform: scale(0.4);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }

    @keyframes slideOut {
        0% {
            opacity: 1;
            transform: translateY(0);
        }
        70% {
            opacity: 1;
        }
        100% {
            opacity: 0;
            transform: translateY(-100%);
        }
    }
</style>
